import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Emoji } from 'emoji-mart';

import { translate } from 'services/i18nService';
import Modal from 'components/Modal/Modal';
import {
  actionCreators as userActions,
  selector as userSelector,
} from 'pages/User/State';

import GuestBillingModalForm from './GuestBillingModalForm/GuestBillingModalForm';
import styles from './GuestBillingModal.css';


@connect(userSelector, (dispatch) => {
  return { userActions: bindActionCreators(userActions, dispatch) };
})
class GuestBillingModal extends PureComponent {
  static propTypes = {
    close: PropTypes.func.isRequired,
    open: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    userActions: PropTypes.object.isRequired,
    show: PropTypes.bool,
  };

  static defaultProps = { show: true };

  constructor(...args) {
    super(...args);

    const { close, user } = this.props;

    this.state = {
      close,
      email: user.email,
      show: true,
    };
  }

  componentDidMount() {
    const { open } = this.props;
    if (open) {
      open();
    }
  }

  closeModal = () => {
    this.props.close();
  };

  render() {
    const { userActions, show } = this.props;
    const { email, close } = this.state;

    return (
      <Modal className={styles.modal} close={close} show={show} showClose={false}>
        <div className={styles.content}>
          <div className={styles.emojis}>
            <Emoji emoji={{ id: 'heart_eyes', skin: 1 }} size={28} />
            <Emoji emoji={{ id: 'eggplant', skin: 1 }} size={28} />
            <Emoji emoji={{ id: 'kiss', skin: 1 }} size={28} />
          </div>
          <h3 className={styles.title}>{translate('strings.almost.member')}</h3>
          <GuestBillingModalForm close={close} email={email} userActions={userActions} />
        </div>
        <div className={styles.modalFooter}>
          <span onClick={this.closeModal}>{translate('v2profile.feedback.no.thanks')}</span>
        </div>
      </Modal>
    );
  }
}

export default GuestBillingModal;
